"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../../colour-constants-partner"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var CollinsonViewOnlyNotice = function(param) {
    var _param_text = param.text, text = _param_text === void 0 ? "*COLLINSON VIEW ONLY" : _param_text, _param_isWidthRequired = param.isWidthRequired, isWidthRequired = _param_isWidthRequired === void 0 ? true : _param_isWidthRequired;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
        style: _extends({}, isWidthRequired && {
            width: "205px"
        }, {
            padding: "8px 16px",
            fontSize: "14px",
            backgroundColor: _colourconstantspartner.default["bg-blue"]
        }),
        children: text
    });
};
var _default = CollinsonViewOnlyNotice;
